// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"483":"13a2f2a15babfb15","888":"0a72bf822920497a"}[chunkId] + ".css";
};